import { render } from "./LimitedCompanyFormUpdate.vue?vue&type=template&id=707a1a45&scoped=true"
import script from "./LimitedCompanyFormUpdate.vue?vue&type=script&lang=js"
export * from "./LimitedCompanyFormUpdate.vue?vue&type=script&lang=js"

import "./LimitedCompanyFormUpdate.vue?vue&type=style&index=0&id=707a1a45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707a1a45"]])

export default __exports__